<app-auth-layout>
    <!-- Show while processing -->
    <div *ngIf="!message" class="processing">
        Processing... <sync-icon name="upload-inprogress"></sync-icon>
    </div>

    <!-- Show success or error message with countdown -->
    <div *ngIf="message" class="result-message">
        <div>
            <sync-icon name="upload-inprogress"></sync-icon>
        </div>
        <div>
            {{ message }} <br/>
            Redirecting to {{ redirectTarget }} in {{ countdown }}s...
        </div>
    </div>
</app-auth-layout>